import { HTTP, authHTTP } from "./axios.service";
import * as jwtDecode from "jwt-decode";

export {
  getToken,
  checkTokenExpiry,
  verifyToken,
  refreshToken,
  logout,
  createUser,
  changeUser,
  activateUser,
  resetPassword,
  resetPasswordConfirm,
  getUserProfile,
  getPermissions,
  getUsers,
  setPassword,
  setSignature
};

function getToken(username, password) {
  return authHTTP.post("auth/jwt/create/", {
    username: username,
    password: password
  });
}

function refreshToken() {
  // Try to refresh assuming that the HTTPONLY cookie is set
  return authHTTP.post("auth/jwt/refresh/cookie/");
}

function checkTokenExpiry(token) {
  const token_exp = jwtDecode(token).exp;
  const now = Date.now().valueOf() / 1000;
  return now < token_exp;
}

function verifyToken(token) {
  return authHTTP.post("auth/jwt/verify/", {
    token: token
  });
}

function logout() {
  return authHTTP.post("auth/logout");
}

function getUserProfile(user_id) {
  return authHTTP.get(`auth/users/${user_id}/`);
}

function getPermissions() {
  return authHTTP.get("auth/permissions/");
}

function getUsers(filters) {
  return authHTTP.get("auth/users/" + filters);
}

function createUser(data) {
  // data: { username, password, re_password }
  return authHTTP.post("auth/users/create/", data);
}

function changeUser(user_id, data) {
  // data: Must match the User model returned from the API.
  return authHTTP.patch(`auth/users/${user_id}/`, data);
}

function activateUser(data) {
  // data: { uid, token }
  return HTTP.post("auth/users/activation/", data);
}

function resetPassword(email) {
  // data: { email }
  return HTTP.post("auth/users/reset_password/", {
    email: email
  });
}

function resetPasswordConfirm(formData) {
  // formData: { uid, token, password, re_password }
  return HTTP.post("auth/users/reset_password/confirm/", formData);
}

function setPassword(formData) {
  return authHTTP.post("auth/users/set_password/", {
    current_password: formData["current_password"],
    new_password: formData["new_password"],
    re_new_password: formData["re_new_password"]
  });
}

function setSignature(formData) {
  return authHTTP.patch("auth/users/set_signature/", {
    password: formData.password,
    signature: formData.new_signature,
    signature_check: formData.check_signature
  });
}
